module.exports = __webpack_public_path__ + "static/media/ad.0875710a.png";